<template>
    <header class="container">
        <nav class="container__nav">
            <section class="container__nav__section_top">
                <div class="navbar">
                    <div class="container nav-container">
                        <input class="checkbox" type="checkbox" name="" id="" />
                        <div class="hamburger-lines">
                            <span class="line line1"></span>
                            <span class="line line2"></span>
                            <span class="line line3"></span>
                        </div>
                        <div class="logo">
                            <h1>Jonathan <br> Despeyroux</h1>
                        </div>
                        <div class="menu-items">
                            <li>
                                <router-link to="/" class="header__nav__article_right__aside_accueil__div__router-link"
                                    id="router-link">
                                    ACCUEIL
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/services"
                                    class="header__nav__article_right__aside_services__div__router-link"
                                    id="router-link">SERVICES
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/apropos"
                                    class="header__nav__article_right__aside_apropos__div__router-link"
                                    id="router-link">À PROPOS
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/contact"
                                    class="header__nav__article_right__aside_contact__div__router-link"
                                    id="router-link">CONTACT
                                </router-link>
                            </li>
                        </div>
                    </div>
                </div>
            </section>
            <!-- color section -->
            <section class="container__nav__section_bottom">
                <div class="container__nav__section_bottom__div-blue"></div>
                <div class="container__nav__section_bottom__div-white"></div>
                <div class="container__nav__section_bottom__div-red"></div>
            </section>
        </nav>
    </header>
</template>

<script >
export default {
    name: 'NavbarMobile'
}

</script>

<style  lang=scss scoped>
@import "@/style/color.scss";
@import "@/style/effets.scss";

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: "Poppins", sans-serif;
}

.container {
    max-width: 1050px;
    width: 90%;
    margin: auto;
}

.navbar {
    width: 100%;
    box-shadow: 0 1px 4px rgb(146 161 176 / 15%);
}

.nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 62px;
}

.navbar .menu-items {
    display: flex;
}

.navbar .nav-container li {
    list-style: none;
}

#router-link{
    color:$RODM;
    font-size: $text;
}

.navbar .nav-container a {
    text-decoration: none;
    color: #0e2431;
    font-weight: 500;
    font-size: 1.2rem;
    padding: 0.7rem;
}

.navbar .nav-container a:hover {
    font-weight: bolder;
}

.nav-container {
    display: block;
    position: relative;
    height: 60px;
}

.nav-container .checkbox {
    position: absolute;
    display: block;
    height: 2rem;
    width: 3rem;
    top: 1rem;
    left: 78vw;
    z-index: 12;
    opacity: 0;
    cursor: pointer;
}

.nav-container .hamburger-lines {
    display: block;
    height: 2rem;
    width: 3rem;
    position: absolute;
    top: 1rem;
    left: 78vw;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.nav-container .hamburger-lines .line {
    display: block;
    height: 4px;
    width: 100%;
    border-radius: 10px;
    background: $BF;
}

.nav-container .hamburger-lines .line1 {
    transform-origin: 0% 0%;
    transition: transform 0.4s ease-in-out;
}

.nav-container .hamburger-lines .line2 {
    transition: transform 0.2s ease-in-out;
}

.nav-container .hamburger-lines .line3 {
    transform-origin: 0% 100%;
    transition: transform 0.4s ease-in-out;
}

.navbar .menu-items {
    padding-top: 120px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6.1px);
    -webkit-backdrop-filter: blur(6.1px);
    height: 22rem;
    position: relative;
    z-index: 9;
    width: 100%;
    transform: translate(-150%);
    display: flex;
    flex-direction: column;
    margin-left: -40px;
    padding-left: 50px;
    transition: transform 0.5s ease-in-out;
    text-align: center;
}

.navbar .menu-items li {
    margin-bottom: 1.2rem;
    font-size: 1.5rem;
    font-weight: bold;
    color: $N;
}

.logo {
    position: absolute;
    top: 0rem;
    right: 78vw;
    color: $N;
}

h1 {
    font-size: 1rem;
}

.nav-container input[type="checkbox"]:checked~.menu-items {
    transform: translateX(0);
}

.nav-container input[type="checkbox"]:checked~.hamburger-lines {
    transform: rotate(90deg);
}

.nav-container input[type="checkbox"]:checked~.logo {
    display: none;
}

//######################################### SCSS
.container {
    height: 4rem;
    width: 100%;
    //overflow: hidden;
}

.container__nav__section_bottom{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 3px;

    &__div-blue{
        background-color: $BF;
        width: 100%;
    }

    &__div-white{
        background-color: white;
        width: 100%;
    }

    &__div-red{
        background-color: $RV;
        width: 100%;
    }
}
</style>